module.exports = __webpack_public_path__ + "img/icon_english_color.3d11ff9a.svg";